/**
 * ラリーのピンを地図へ重ねるレイヤー
 *
 * 地図そのものは呼び出し側が用意する。画面をまたいで 1 つの地図を使い回すシェルからも、
 * 単体のピッカーからも同じピンを載せられるようにするため。
 */

import type { RallyMapItem } from '@/api/types/stamp-rally'
import type { Coords } from '@/hooks/useCurrentPosition'

import { GoogleCircleMarker } from './google-circle-marker'
import { RallyMapMarkers } from './rally-map-markers'
import type { RallyPlaceGroup } from './rally-place-popup'
import type { RallyPlacesResult } from './use-rally-places'

const ORIGIN_COLOR = '#3B82F6'

type Props = {
  rallyPlaces: RallyPlacesResult
  /** ポップアップを開いている場所。useRallyPlaces の keepPlaceId にも同じ値を渡す */
  activePlaceId: number | null
  onActivate: (placeId: number | null) => void
  selectedPlaceIds: number[]
  onToggle: (place: RallyPlaceGroup) => void
  /** ポップアップのラリー行を押したときの動き。省略するとそのラリーの詳細へ飛ぶ */
  onSelectItem?: (item: RallyMapItem) => void
  /** 地図からスタンプを押したあとに呼ぶ。リスト側を引き直す用 */
  onStampChanged?: () => void
  /** 現在地。渡すと青丸を重ねる */
  origin?: Coords | null
}

export const RallyMapLayer = ({
  rallyPlaces,
  activePlaceId,
  onActivate,
  selectedPlaceIds,
  onToggle,
  onSelectItem,
  onStampChanged,
  origin = null,
}: Props) => (
  <>
    {origin && (
      <GoogleCircleMarker
        position={{ lat: origin.latitude, lng: origin.longitude }}
        radius={6}
        color="#FFFFFF"
        fillColor={ORIGIN_COLOR}
        weight={2}
        zIndex={5}
      />
    )}

    <RallyMapMarkers
      visible={rallyPlaces.visible}
      colorOf={rallyPlaces.colorOf}
      selectedPlaceIds={selectedPlaceIds}
      activePlaceId={activePlaceId}
      onActivate={onActivate}
      onToggle={onToggle}
      onToggleStamp={(item, stamped) => {
        void rallyPlaces.toggleStamp(item, stamped).then(() => onStampChanged?.())
      }}
      onSelectItem={onSelectItem}
    />
  </>
)
